import * as React from "react";
const SvgIcDrag = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.5 9.167h-15V7.5h15v1.667Zm0 1.666h-15V12.5h15v-1.667Z" /></svg>;
export default SvgIcDrag;